'use client';

import { ReactNode, useState } from 'react';
import { Agent as LoggedInAgent } from '../agent';
import { AtpAgent as LoggedOutAgent } from '@atproto/api';

const defaultProvider = process.env['NEXT_PUBLIC_DEFAULT_PROVIDER'];

export function Login({ onLogin }: { onLogin: (agent: LoggedInAgent) => void }):
    ReactNode {
  const [provider, setProvider] = useState(defaultProvider);
  const [handle, setHandle] = useState('');
  const [password, setPassword] = useState('');

  /** Log in the user and emit the created {@link LoggedInAgent}. */
  async function login(): Promise<void> {
    // Validate inputs.
    if (!provider || !handle || !password) {
      console.error('Missing provider, handle, or password');
      return;
    }

    // Log in the user.
    const identifier = handle.startsWith('@') ? handle.slice(1) : handle;
    const agent = new LoggedOutAgent({ service: provider });
    const res = await agent.login({ identifier, password });
    if (!res.success) {
      console.error('Failed to login.');
      return;
    }

    // Emit the event.
    onLogin(agent as LoggedInAgent);
  }

  return (
    <form action="#" onSubmit={(e) => { e.preventDefault(); login(); }}>
      <div>
        <label>Provider:
          <input
            type="text"
            value={provider}
            onChange={(e) => setProvider(e.target.value)}
            placeholder="https://bsky.social"
          />
        </label>
      </div>

      <div>
        <label>Handle:
          <input
            type="text"
            value={handle}
            onChange={(e) => setHandle(e.target.value)}
            placeholder="@develwithoutacause.dwac.dev"
          />
        </label>
      </div>

      <div>
        <label>Password:
          <input
            type="password"
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>
      </div>

      <button type="submit">Login</button>
    </form>
  );
}
